<template>
    <div>
        <o-table :title="$t('sandoz.plan_data')"
                 ref="tableList"
                 url="/api/sandoz/plan_data"
                 default-sort-by="id"
                 default-sort-by-direction="desc"
                 :enable-new="false"
                 :enable-edit="false"
                 :enable-delete="false"
                 :enable-page-length="true">
            <template slot="filter">
                <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                    <o-filter-select :items="years" :title="$t('sandoz.year')" column="year"></o-filter-select>
                    <o-filter-select :items="contractTypes" :title="$t('sandoz.contract_type')" column="type"></o-filter-select>
                    <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
                </o-filter>
                <div class="pull-right">
                    <b-btn variant="primary" v-b-modal.import-plan-data>
                        <fa icon="file-import" class="mr-1"/>
                        {{$t('sandoz.import_data')}}
                    </b-btn>
                </div>
            </template>
            <template slot="head">
                <o-table-header column="customer_external_id">{{$t('sandoz.customer_external_id')}}</o-table-header>
                <o-table-header column="type">{{$t('sandoz.contract_type')}}</o-table-header>
                <o-table-header column="year">{{$t('sandoz.year')}}</o-table-header>
                <o-table-header column="outlook">{{$t('sandoz.outlook')}}</o-table-header>
                <o-table-header column="turnover_actual">{{$t('sandoz.turnover_actual')}}</o-table-header>
                <o-table-header column="turnover_expectation">{{$t('sandoz.turnover_expectation')}}</o-table-header>
                <o-table-header column="target_invest">{{$t('sandoz.target_invest')}}</o-table-header>
                <o-table-header column="target_discount">{{$t('sandoz.target_discount')}}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>{{ props.item.customer_external_id }}</td>
                <td>{{ props.item.type }}</td>
                <td>{{ props.item.year }}</td>
                <td>{{ props.item.outlook }}</td>
                <td>{{ props.item.turnover_actual }}</td>
                <td>{{ props.item.turnover_expectation }}</td>
                <td>{{ props.item.target_invest }}</td>
                <td>{{ props.item.target_discount }}</td>
            </template>
        </o-table>

        <!-- Import Data Modal -->
        <b-modal id="import-plan-data" :title="$t('sandoz.plan_data_import')" :ok-title="$t('sandoz.upload')"
                 @ok.prevent="upload" :ok-disabled="form.file === null || form.year === null || form.type === null">
            <alert-error :form="form" :message="$t('sandoz.file_import_failed')"></alert-error>
            <alert-success :form="form" :message="$t('sandoz.file_import_success')"></alert-success>
            <o-file-upload v-model="form.file" :allow-clear="true" :allow-download="false">
            </o-file-upload>
            <o-value-select v-model="form.year" :items="years" :label="$t('sandoz.year')"/>
            <o-value-select v-model="form.type" :items="contractTypes" :label="$t('sandoz.type')"/>
        </b-modal>
    </div>
</template>

<script>
  import Form from 'vform'

  export default {
    data: () => ({
      contractTypes: [],
      years: [],
      form: new Form({
        file: null,
        year: null,
        type: null
      })
    }),
    created () {
      var currentYear = (new Date()).getYear() + 1900
      if ((new Date()).getMonth() > 5) {
        currentYear++
      }

      for (var year = 2023; year <= currentYear; year++) {
        this.years.push({ value: year, text: year + '' })
      }
      this.contractTypes = [
        { value: 'APO', text: this.$i18n.t('sandoz.apo') },
        { value: 'SD', text: this.$i18n.t('sandoz.sd') },
        { value: 'IMMUNO', text: this.$i18n.t('sandoz.immuno') },
        { value: 'ONCO', text: this.$i18n.t('sandoz.onco') },
        { value: 'CNS', text: this.$i18n.t('sandoz.cns') },
        {value: 'HEIM', text: this.$i18n.t('sandoz.heim')},
        {value: 'SD_GADGET', text: this.$i18n.t('sandoz.sd_gadget')},
        {value: 'CNS_GADGET', text: this.$i18n.t('sandoz.cns_gadget')},
        /*{value: 'ONCO_GADGET', text: this.$i18n.t('sandoz.onco_gadget')},*/
        {value: 'IMMUNO_GADGET', text: this.$i18n.t('sandoz.immuno_gadget')},
        {value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget')},
        {value: 'APO_GADGET', text: this.$i18n.t('sandoz.apo_gadget')},
        {value: 'KAM_APO_GADGET', text: this.$i18n.t('sandoz.kam_apo_gadget')},
        {value: 'BIOS_APO', text: this.$i18n.t('sandoz.bios_apo')},
        {value: 'KAM_APO', text: this.$i18n.t('sandoz.kam_apo')},
        {value: 'KAM_SD', text: this.$i18n.t('sandoz.kam_sd')},
        {value: 'KAM_WHS', text: this.$i18n.t('sandoz.kam_whs')},
        {value: 'KAM_DIVERSE_HOSP', text: this.$i18n.t('sandoz.kam_diverse_hosp')},
        {value: 'KAM_DIVERSE_INSUR', text: this.$i18n.t('sandoz.kam_diverse_insur')},
        {value: 'KAM_SD_SORTALYS', text: this.$i18n.t('sandoz.kam_sd_sortlays')},
        {value: 'SD_EDU', text: this.$i18n.t('sandoz.sd_edu')},
        {value: 'CNS_EDU', text: this.$i18n.t('sandoz.cns_edu')},
        {value: 'IMMUNO_EDU', text: this.$i18n.t('sandoz.immuno_edu')},
        {value: 'ONCO_EDU', text: this.$i18n.t('sandoz.onco_edu')},
        {value: 'KAM_SD_EDU', text: this.$i18n.t('sandoz.kam_sd_edu')},
        {value: 'APO_EDU', text: this.$i18n.t('sandoz.apo_edu')},
        {value: 'KAM_APO_EDU', text: this.$i18n.t('sandoz.kam_apo_edu')},
        {value: 'HIGHSPEC_GADGET', text: this.$i18n.t('sandoz.highspec_gadget')},
        {value: 'BIOS_KAM_APO', text: this.$i18n.t('sandoz.bios_kam_apo')},
        {value: 'BIOS_KAM_WHS', text: this.$i18n.t('sandoz.bios_kam_whs')},
        { value: 'APO_OTC', text: this.$i18n.t('sandoz.apo_otc') },
        { value: 'APO_KUKO', text: this.$i18n.t('sandoz.apo_kuko') },
        { value: 'SD_KUKO', text: this.$i18n.t('sandoz.sd_kuko') },
        { value: 'IMMUNO_KUKO', text: this.$i18n.t('sandoz.immuno_kuko') },
        { value: 'HOSP_KUKO', text: this.$i18n.t('sandoz.hosp_kuko') },
        { value: 'CNS_KUKO', text: this.$i18n.t('sandoz.cns_kuko') },
      ]
    },
    methods: {
      async upload(bvModalEvt) {
        bvModalEvt.preventDefault()
        try {
          await this.form.post('/api/sandoz/plan_data/save')
          this.form.reset()
          this.$bvModal.hide('import-plan-data')
          this.$refs.tableList.search()
        } catch (e) {
          // form errors are shown via alert-error
        }
      }
    }
  }
</script>
